export default {
  strings: {
    nav: {
      home: "Головна",
      services: "Послуги",
      personal: "Персональна підтримка",
      about: "Про нас",
      packages: "Пакети",
      faq: "FAQ",
      contact: "Контакти",
      book: "Забронювати консультацію",
    },
    common: {
      book: "Забронювати консультацію",
      quote: "Отримати розрахунок",
      viewServices: "Переглянути послуги",
    },
    whatsapp: {
      label: "Чат у WhatsApp",
      prefill: "Вітаю, VCK Business Lab! Хочу дізнатися більше про ваші послуги.",
    },
    footer: {
      tagline: "Вдосконалена віртуальна підтримка для сучасного бізнесу",
      blurb:
        "Надійна, конфіденційна та детальна віртуальна адміністративна підтримка — на 100% віддалено для клієнтів у Канаді, США, Європі та по всьому світу.",
      explore: "Навігація",
      services: "Послуги",
      ownerLogin: "Вхід для власника",
      rights: "VCK Business Lab. Усі права захищено.",
      virtual: "100% віддалено · Весь світ",
      quote: "Отримати розрахунок",
    },
    cta: {
      overline: "Довірте деталі нам.",
      title: "Витрачайте менше часу на адміністрування і більше — на розвиток свого бізнесу.",
      book: "Забронювати консультацію",
      quote: "Отримати розрахунок",
    },
    home: {
      heroOverline: "VCK Business Lab · 100% віддалено · Весь світ",
      heroLine1: "Професійна віртуальна підтримка",
      heroLine2: "для бізнесу та повсякденного життя.",
      heroSub:
        "Адміністративна, бізнесова та багатомовна підтримка для компаній, професіоналів, приватних осіб і новоприбулих — на 100% віддалено в Канаді та по всьому світу.",
      heroStats: [
        { stat: "100%", label: "Віддалена робота з будь-якої точки" },
        { stat: "Весь світ", label: "Канада · США · Європа · далі" },
        { stat: "Бутік", label: "Конфіденційна персональна підтримка" },
      ],
      extOverline: "Продовження вашого бізнесу",
      extTitle: "Надійна підтримка без найму штатного працівника.",
      extCopy:
        "VCK Business Lab працює як органічне продовження вашого бізнесу — надаючи надійну, конфіденційну та детальну адміністративну підтримку без витрат і зобов'язань штатного працівника.",
      extPoints: [
        { title: "Надійність", text: "Стабільна підтримка, на яку можна планувати." },
        { title: "Конфіденційність", text: "Інформація вашого бізнесу обробляється зі суворою конфіденційністю та розумними заходами захисту." },
        { title: "Увага до деталей", text: "Кожне завдання виконується ретельно та на високому рівні." },
      ],
      svcOverline: "Послуги",
      svcTitle: "Все на вашому столі — делікатно вирішене.",
      svcCopy: "Наші напрями підтримки — віддалено та адаптовано під ваш стиль роботи та життя.",
      svcViewAll: "Усі послуги",
      svcViewDetails: "Детальніше",
      splitOverline: "Підтримка, створена навколо вас",
      splitTitle: "Два напрями. Один стандарт турботи.",
      splitCopy: "Чи ви керуєте бізнесом, чи будуєте нове життя — VCK зустрічає вас там, де ви є.",
      splitBizTitle: "Бізнес-послуги",
      splitBizText:
        "Віртуальна адміністративна, управлінська, багатомовна, документна, проєктна та вебпідтримка для компаній, підприємців і професіоналів у всьому світі.",
      splitBizPoints: ["Адміністративна підтримка та підтримка керівників", "Переклад і багатомовна комунікація", "Документи, проєкти та вебсайти"],
      splitBizCta: "Переглянути бізнес-послуги",
      splitPerTitle: "Персональна підтримка та підтримка новоприбулих",
      splitPerText:
        "Турботлива, конфіденційна підтримка для приватних осіб, сімей і новоприбулих до Канади — повсякденні справи, вирішені вашою мовою.",
      splitPerPoints: ["Мовна допомога та допомога у спілкуванні", "Допомога зі страхуванням, банками та комунальними послугами", "Житло, школи та повсякденне адміністрування"],
      splitPerCta: "Переглянути персональну підтримку",
      stepsOverline: "Як це працює",
      stepsTitle: "Від першого дзвінка до повного фокусу — чотири кроки.",
      whyOverline: "Чому VCK",
      whyTitle: "Стандарт, який заслуговує ваш бізнес.",
      whyCopy: "Більше ніж виконання завдань — професійне партнерство, побудоване на довірі, точності та конфіденційності.",
      whoOverline: "З ким ми працюємо",
      whoTitle: "Нас обирають ті, хто рухає бізнес вперед.",
      testOverline: "Відгуки",
      testTitle: "Історії клієнтів.",
      testLaunch: "Наразі ми запрошуємо наших перших пілотних клієнтів. Досвід клієнтів і кейси будуть додані в міру зростання VCK.",
      packOverline: "Постійні плани підтримки",
      packTitle: "Щомісячна підтримка, адаптована під вас.",
      packCopy:
        "Гнучкі щомісячні пакети в USD — жодних жорстких підписок. Фінальна вартість погоджується після короткої консультації.",
      packViewAll: "Переглянути пакети",
      packIncluded: "Що входить",
      packGlobalTitle: "Global Priority",
      packGlobalText:
        "Міжнародна, багатомовна, розширена за часом або високообсягова підтримка — повністю індивідуальні щомісячні домовленості з власними процесами та пільговими екстреними тарифами.",
      packGlobalBtn: "Отримати індивідуальний розрахунок",
      faqOverline: "Поширені запитання",
      faqTitle: "Відповіді — ще до запитання.",
      faqViewAll: "Усі запитання",
      loyaltyText:
        "Постійні клієнти отримують до 36 безкоштовних годин підтримки, пріоритетні переваги та вітальний пакет VCK.",
      loyaltyCta: "Програма лояльності",
    },
    services: {
      overline: "Послуги та ціни",
      line1: "Послуги, створені навколо",
      line2: "вас.",
      intro:
        "Від щоденного адміністрування до багатомовної комунікації та термінової міжнародної підтримки — VCK Business Lab надає гнучку багатомовну підтримку для бізнесів, професіоналів, новоприбулих, іноземних студентів та міжнародних клієнтів.",
      languages: "English | Українська | العربية | Other Languages",
      worldwide: "Клієнти по всьому світу • 100% віддалено",
      showLess: "Згорнути",
      pricing: "Ціни",
      plansOverline: "Постійні плани підтримки",
      plansTitle: "Щомісячна підтримка, адаптована під вас.",
      plansCopy: "Це не жорсткі підписки — кожен план можна адаптувати під ваші години, послуги, мови та пріоритети.",
      disOverline: "Гнучкі ціни для кожного бізнесу",
      disQuote:
        "«Зазначені ціни — стартові тарифи в USD. Фінальна вартість залежить від складності, мовної комбінації, терміновості, необхідної експертизи, обсягу та вимог до послуги. Доступні щомісячні пакети та проєктне ціноутворення.»",
      disNote: "Довгострокові зобов'язання не потрібні, якщо інше не передбачено сервісним контрактом.",
    },
    packages: {
      availabilityNote: "Зазначені ціни є початковими, а всі послуги надаються за наявності. Обсяг, результати, терміни, вартість і правки підтверджуються в письмовому розрахунку або угоді.",
      overline: "Пакети",
      line1: "Підтримка, що масштабується",
      line2: "під ваше навантаження.",
      intro:
        "Кожна співпраця починається зі стартового тарифу, який уточнюється після короткої консультації — ви платите лише за потрібну підтримку. Без примусу до покупки: почніть із розрахунку.",
      note: "Це не жорсткі підписки — кожен план можна адаптувати під ваші години, послуги, мови та пріоритети.",
      mostRequested: "Найпопулярніший",
      startingFrom: "Починаючи від",
      tailored: "Індивідуально",
      requestQuote: "Отримати розрахунок",
      quoteNote: "Без онлайн-оплати на сайті — після підтвердження обсягу та вартості ми надсилаємо вам безпечне платіжне посилання безпосередньо.",
      compareOverline: "Порівняння пакетів",
      compareTitle: "Знайдіть свій варіант з першого погляду.",
      compareIncluded: "Включено",
      disOverline: "Гнучкі ціни для кожного бізнесу",
      disQuote:
        "«Зазначені ціни — стартові тарифи в USD. Фінальна вартість залежить від складності, мовної комбінації, терміновості, необхідної експертизи, обсягу та вимог до послуги. Доступні щомісячні пакети та проєктне ціноутворення.»",
      disNote: "Довгострокові зобов'язання не потрібні, якщо інше не передбачено сервісним контрактом.",
      loyaltyOverline: "Програма лояльності",
      loyaltyTitle: "Більше підтримки. Більше цінності. Більше причин залишатися.",
      loyaltyIntro:
        "У VCK Business Lab ми цінуємо довгострокові партнерства. Обираючи постійний план підтримки, ви отримуєте безкоштовні години, пріоритетні переваги та вітальний подарунок VCK.",
      bestValue: "Найвигідніше",
      welcomeOverline: "Маленький подарунок від VCK",
      welcomeTitle: "Кожен новий постійний клієнт має відчути себе бажаним.",
      welcomeText:
        "Клієнти, які відповідають умовам, отримують безкоштовний вітальний пакет VCK — з турботою підготовлений як подяка за вибір нас як партнера з підтримки бізнесу.",
      welcomeNote: "Без жодної доплати — просто наш спосіб сказати: ласкаво просимо до VCK.",
      welcomeInclude: "Ваш пакет може містити",
      welcomeItems: ["Преміальні настільні аксесуари", "Бізнес-аксесуари", "Брендовані речі VCK", "Персональний вітальний подарунок"],
      bonusOverline: "Ваші бонусні години — ваш вибір",
      bonusTitle: "Використовуйте додаткові години тоді, коли потрібна додаткова пара рук.",
      bonusText: "Безкоштовні години можна використати для відповідних послуг VCK, зокрема:",
      builtOverline: "Створено навколо вашого бізнесу",
      builtTitle: "Не знаєте, який пакет підійде саме вам?",
      builtText: "Ми створимо план підтримки під ваше навантаження, мови, часовий пояс і потреби бізнесу.",
      builtBook: "Безкоштовна консультація",
      builtOr: "або",
      builtQuote: "Персональний розрахунок",
      welcomeLine: "Ласкаво просимо до VCK Business Lab",
      welcomeTagline: "Глобальна підтримка · Багатомовна експертиза · Бізнес-партнер, на якого можна покластися",
      referOverline: "Реферальна програма",
      referTitle: "Діліться VCK. Отримуйте безкоштовну підтримку.",
      referIntro:
        "Подобається працювати з VCK Business Lab? Порекомендуйте нас іншому бізнесу та отримайте безкоштовні години підтримки, коли він стане клієнтом VCK.",
      referSteps: [
        {
          title: "Порекомендуйте бізнес",
          text: "Познайомте VCK Business Lab із бізнесом, професіоналом чи підприємцем, якому будуть корисні наші послуги.",
        },
        { title: "Вони приєднуються до VCK", text: "Ваш реферал підписує відповідний пакет зобов'язань VCK." },
        {
          title: "Ви отримуєте безкоштовні години",
          text: "Щойно їхня угода починається, безкоштовні години підтримки додаються на ваш рахунок як наша подяка.",
        },
      ],
      referRewardsTitle: "Реферальні винагороди",
      referTiers: [
        { plan: "Реферал підписує пакет на 1 місяць", hours: "Отримайте 2 безкоштовні години" },
        { plan: "Реферал підписує пакет на 3 місяці", hours: "Отримайте 5 безкоштовних годин" },
        { plan: "Реферал підписує пакет на 6 місяців", hours: "Отримайте 10 безкоштовних годин" },
        { plan: "Реферал підписує пакет на 12 місяців", hours: "Отримайте 20 безкоштовних годин" },
      ],
      referMoreTitle: "Рекомендуйте більше. Отримуйте більше.",
      referMoreText:
        "Не зупиняйтеся на одній рекомендації. Рекомендуйте кілька бізнесів і продовжуйте заробляти безкоштовні години підтримки VCK, коли відповідні реферали стають клієнтами.",
      referMilestones: [
        { count: "3 успішні рекомендації", reward: "Отримайте додатково 5 бонусних годин" },
        { count: "5 успішних рекомендацій", reward: "Отримайте додатково 10 бонусних годин" },
        { count: "10 успішних рекомендацій", reward: "Спеціальна винагорода лояльності VCK плюс додаткова безкоштовна підтримка" },
      ],
      referThanksOverline: "Подяка за те, що ростете з нами",
      referThanksText:
        "Наш бізнес росте завдяки стосункам, і ми хочемо, щоб наші клієнти отримували вигоду, представляючи VCK іншим. Ваші безкоштовні реферальні години можна використати для відповідних послуг, таких як:",
      referServices: [
        "Віртуальна адміністративна підтримка",
        "Підтримка керівників",
        "Багатомовна бізнес-підтримка",
        "Документні та проєктні послуги",
        "Перекладацькі послуги",
        "Інші відповідні послуги VCK",
      ],
      referCtaTitle: "Знаєте бізнес, якому стане в пригоді VCK?",
      referCtaText: "Допоможіть іншому бізнесу відкрити надійну глобальну підтримку — і отримайте додаткові години VCK від нас.",
      referCtaBtn: "Порекомендувати бізнес",
    },
    about: {
      overline: "Про VCK",
      line1: "Бутік-партнер для роботи,",
      line2: "що стоїть за вашою роботою.",
      intro:
        "VCK Business Lab створена, щоб надавати бізнесам і професіоналам надійну, організовану та високоякісну віртуальну адміністративну підтримку — з турботою бутік-компанії, а не дистанцією великої корпорації.",
      storyOverline: "Чому ми існуємо",
      storyTitle: "Створені, щоб повернути вам ваш час.",
      storyP1:
        "Рутинна адміністративна робота тихо поглинає найцінніші години. VCK Business Lab існує, щоб зняти цю вагу з вашого столу — спрощуючи бізнес-операції гнучкою професійною підтримкою без витрат і зобов'язань додаткового штатного працівника.",
      storyP2:
        "Професіоналізм, організованість, комунікація, конфіденційність та увага до деталей — не маркетингові слова, а робочий стандарт кожної скриньки, документа та наради.",
      manOverline: "Наші принципи",
      manTitle: "Три зобов'язання, які ми дотримуємося щодня.",
      globalOverline: "Глобальне охоплення",
      globalTitle: "Де б ви не вели бізнес — ми поруч.",
      globalCopy: "Усі послуги надаються на 100% віддалено, тож VCK підтримує клієнтів безшовно через часові пояси та кордони.",
      regions: ["Канада", "Сполучені Штати", "Європа", "Міжнародно"],
      valuesOverline: "Ключові цінності",
      valuesTitle: "Чого очікувати — щоразу.",
      whoOverline: "З ким ми працюємо",
      whoTitle: "Створено для зайнятих людей і бізнесів, що ростуть.",
    },
    faqPage: {
      overline: "FAQ",
      line1: "Відповіді —",
      line2: "ще до запитання.",
      intro: "Запитання, які клієнти ставлять найчастіше про роботу з VCK Business Lab. Якщо вашого тут немає — ми за одне повідомлення.",
      calloutOverline: "Залишилися запитання?",
      calloutTitle: "Обговорімо — без зобов'язань.",
      calloutText: "Безкоштовна ознайомча консультація — найпростіший спосіб отримати відповіді саме для вашого бізнесу.",
      calloutBtn: "Безкоштовна консультація",
    },
    contact: {
      overline: "Контакти",
      line1: "Поговорімо про",
      line2: "ваше навантаження.",
      intro: "Розкажіть, що ви хочете зняти зі свого столу. На кожне звернення ми відповідаємо особисто протягом одного робочого дня.",
      consultTitle: "Безкоштовна консультація",
      consultText:
        "Заплануйте безкоштовну ознайомчу консультацію, щоб обговорити потреби вашого бізнесу — без зобов'язань і тиску. Ми порадимо тип і рівень підтримки, що підійде саме вам.",
      consultPoints: [
        "Ознайомчий дзвінок у зручний для вас час",
        "Індивідуальна рекомендація під ваше навантаження",
        "Жодних зобов'язань продовжувати",
      ],
      consultBtn: "Безкоштовна консультація",
      consultNote:
        "Усі послуги надаються на 100% віддалено. Звернення міжнародних клієнтів — з Канади, США, Європи та інших країн — завжди вітаються.",
      trackLabel: "Я звертаюся як",
      trackBusiness: "Бізнес",
      trackPersonal: "Приватна особа / новоприбулий",
      trackRequired: "Будь ласка, вкажіть, чи звертаєтеся ви як бізнес, чи як приватна особа.",
      formTitle: "Надіслати запит",
      formSub: "Попросіть розрахунок або поставте запитання — решту ми візьмемо на себе.",
      name: "Ім'я",
      company: "Компанія",
      email: "Електронна пошта",
      phone: "Телефон",
      country: "Країна",
      support: "Тип потрібної підтримки",
      hours: "Орієнтовна кількість годин на тиждень",
      preferred: "Бажаний спосіб зв'язку",
      description: "Опис проєкту",
      optional: "— необов'язково",
      phName: "Ваше повне ім'я",
      phCompany: "Компанія або посада",
      phEmail: "vy@company.com",
      phPhone: "+380 __ ___ __ __",
      phCountry: "Де ви перебуваєте",
      phDescription: "Розкажіть про завдання чи проєкти, з якими потрібна підтримка…",
      selectService: "Оберіть послугу",
      selectHours: "Оберіть орієнтовний обсяг",
      selectPreferred: "Як з вами зв'язатися?",
      freeConsultation: "Безкоштовна консультація",
      customProject: "Індивідуальний проєкт",
      notSure: "Ще не знаю",
      hoursOptions: ["1–5 годин", "5–10 годин", "10–20 годин", "20+ годин", "Разовий проєкт", "Ще не знаю"],
      contactOptions: ["Електронна пошта", "Телефон", "Відеодзвінок"],
      planPrefill: "Я хотів(ла) б отримати розрахунок для пакета {name}.",
      referralPrefill: "Я хочу порекомендувати бізнес компанії VCK Business Lab.",
      submit: "Надіслати запит",
      sending: "Надсилаємо…",
      successTitle: "Дякуємо — ваш запит отримано.",
      successText: "Ми відповімо протягом одного робочого дня. Лист-підтвердження вже прямує до вас.",
      errorTitle: "Щось пішло не так під час надсилання.",
      errorText: "Будь ласка, спробуйте ще раз трохи згодом.",
    },
    personal: {
      overline: "Персональна підтримка та підтримка новоприбулих",
      line1: "Повсякденна підтримка для",
      line2: "життя в новій країні.",
      intro:
        "Переїзд до нової країни — чи просто насичене особисте життя — це листи, дзвінки, форми та зустрічі, часто мовою, що не є рідною. VCK Business Lab пропонує турботливу, конфіденційну віртуальну підтримку для приватних осіб, сімей і новоприбулих до Канади.",
      languages: "English | Українська | العربية",
      worldwide: "Приватні особи та сім'ї по всьому світу • 100% віддалено",
      whoOverline: "Для кого це",
      whoTitle: "Підтримка для моментів, що мають значення.",
      whoList: ["Новоприбулі до Канади", "Приватні особи та сім'ї", "Люди старшого віку", "Студенти", "Зайняті професіонали", "Усі, хто обмежено володіє англійською"],
      svcOverline: "Як ми допомагаємо",
      svcTitle: "Персональна підтримка — вашою мовою.",
      svcCopy: "Підтримка у повсякденних справах адаптації та організації — віддалено, терпляче та конфіденційно.",
      services: [
        {
          title: "Мовна допомога",
          text: "Повсякденні листи, електронні листи, форми та телефонні дзвінки — зрозумілі та опрацьовані вашою мовою.",
          items: ["Роз'яснення офіційних та електронних листів", "Допомога у заповненні повсякденних форм", "Підтримка телефонних дзвінків вашою мовою", "Повсякденний (несертифікований) переклад"],
        },
        {
          title: "Комунікація зі страховими та банками",
          text: "Чітке, впевнене спілкування з банками, страховими та постачальниками послуг.",
          items: ["Підготовка до дзвінків у банк і страхову", "Роз'яснення листування та виписок", "Запис на зустрічі", "Листи-нагадування від вашого імені"],
        },
        {
          title: "Комунальні послуги та рахунки",
          text: "Підключення послуг і контроль щомісячних зобов'язань.",
          items: ["Оформлення інтернету, телефону та комунальних послуг", "Роз'яснення щомісячних рахунків", "Організація сервісних візитів", "Порівняння тарифних планів"],
        },
        {
          title: "Підтримка з житлом",
          text: "Спокійна, організована допомога в процесі оренди.",
          items: ["Спілкування з орендодавцями та керуючими компаніями", "Планування переглядів житла", "Роз'яснення орендного листування", "Чек-листи заселення та виселення"],
        },
        {
          title: "Школи та сім'я",
          text: "Підтримка щоденної координації вашої родини.",
          items: ["Підтримка реєстрації в школі", "Спілкування з вчителями", "Форми для громадських програм", "Планування дитячих активностей"],
        },
        {
          title: "Повсякденне адміністрування",
          text: "Дрібні справи, що тихо накопичуються, — вирішені.",
          items: ["Запис на прийоми та нагадування", "Організація особистих документів", "Форматування резюме та супровідних листів", "Керування календарем і розкладом"],
        },
      ],
      stepsOverline: "Як це працює",
      stepsTitle: "Просто — з першого повідомлення.",
      steps: [
        { title: "Розкажіть нам", text: "Поділіться, з чим потрібна допомога, — рідною мовою, у повідомленні або на безкоштовній консультації." },
        { title: "Погоджуємо", text: "Ми підтверджуємо обсяг і чітку стартову ціну до початку будь-якої роботи." },
        { title: "Ми все беремо на себе", text: "Дзвінки, форми, листи та організація — терпляче та конфіденційно." },
        { title: "Ви в курсі", text: "Чіткі оновлення вашою мовою на кожному кроці." },
      ],
      disOverline: "Важливо знати",
      disTitle: "Чіткі межі — свідомо.",
      disIntro:
        "VCK Business Lab надає лише адміністративну, організаційну та комунікаційну підтримку. Ми уважно — і прозоро — окреслюємо те, чого не робимо.",
      disclaimers: [
        {
          title: "Жодних імміграційних консультацій",
          text: "VCK Business Lab не надає імміграційних порад чи консультацій і не готує, не перевіряє та не подає імміграційні заяви. З імміграційних питань звертайтеся до ліцензованого канадського імміграційного консультанта (RCIC) або імміграційного адвоката.",
        },
        {
          title: "Жодних юридичних, фінансових чи страхових порад",
          text: "Ми не надаємо юридичних, фінансових, страхових, податкових чи медичних порад. Наша роль — комунікація, організація та адміністрування; рішення завжди залишаються за вами та вашими ліцензованими фахівцями.",
        },
        {
          title: "Лише несертифікований переклад",
          text: "Переклади в межах персональної підтримки — це загальні, несертифіковані переклади для повсякденного розуміння. Ми не надаємо присяжні, нотаріально завірені чи судово визнані переклади.",
        },
        {
          title: "Завжди правильний фахівець",
          text: "Коли ваша ситуація потребує ліцензованого чи регульованого фахівця, ми завжди скажемо про це — і допоможемо знайти правильного.",
        },
      ],
      partnerOverline: "Адміністративна та мовна підтримка після прибуття в Канаді",
      partnerTitle: "Ми доповнюємо фахівців, які допомагають вам переїхати.",
      partnerLine: "Ви допомагаєте своїм клієнтам потрапити до Канади. VCK Business Lab підтримує їх після прибуття.",
      partnerText:
        "VCK Business Lab працює поруч з імміграційними консультантами, освітніми агенціями, коледжами, рекрутерами та релокаційними компаніями — і ніколи замість них.",
      partnerTypesLabel: "Хто рекомендує нас",
      partnerTypes: ["Імміграційні консультанти (RCIC) та адвокати", "Освітні агенції та коледжі", "Рекрутери та роботодавці", "Релокаційні компанії", "Поселенські та громадські організації"],
      partnerWhyTitle: "Чому партнери рекомендують VCK",
      partnerWhy: [
        { title: "Їхньою мовою", text: "Клієнти отримують підтримку англійською, українською, арабською та іншими мовами — нічого не губиться у перекладі." },
        { title: "Чіткі межі", text: "Ми надаємо лише адміністративну та мовну підтримку — ніколи не даємо імміграційних чи регульованих порад, тому доповнюємо вашу роботу, а не конкуруємо з нею." },
        { title: "Швидко та надійно", text: "Кожен рекомендований клієнт отримує відповідь протягом одного робочого дня та безкоштовну ознайомчу консультацію." },
        { title: "Конфіденційно за замовчуванням", text: "Інформація клієнтів обробляється зі строгою конфіденційністю; за потреби доступні угоди про конфіденційність." },
      ],
      partnerCta: "Обговорити партнерство за рекомендаціями",
      ctaOverline: "Вам не потрібно розбиратися з усім самотужки.",
      ctaTitle: "Розкажіть, що вам потрібно, — рідною мовою.",
      ctaText: "Безкоштовна ознайомча консультація — найпростіший спосіб почати. Без зобов'язань і тиску.",
    },
  },
  data: {
    services: [
      {
        title: "Віртуальна підтримка бізнесу та керівників",
        tagline: "Професійна віддалена адміністративна та управлінська підтримка для підприємців, керівників, професіоналів і бізнесів у всьому світі.",
        price: "Від $30 USD/год",
        featured: ["Керування поштою та скринькою", "Календар і планування", "Підтримка керівників", "Координація нарад", "Адміністрування проєктів"],
        moreLabel: "Усі послуги бізнес-підтримки",
        groups: [
          {
            heading: null,
            items: [
              "Керування електронною поштою та скринькою",
              "Керування календарем",
              "Запис на зустрічі",
              "Організація нарад",
              "Координація нарад",
              "Керування календарем керівника",
              "Загальна підтримка віртуального асистента",
              "Адміністративна допомога",
              "Введення даних",
              "Організація файлів",
              "Цифрове архівування",
              "Оновлення баз даних",
              "Онлайн-дослідження",
              "Адміністративні follow-up",
              "Відстеження завдань",
              "Ведення електронних таблиць",
              "Підготовка порядку денного",
              "Протоколи нарад",
              "Нотатки нарад",
              "Контроль виконання завдань",
              "Професійне листування",
              "Пошук варіантів подорожей",
              "Організація подорожей",
              "Координація подій",
              "Адміністрування проєктів",
              "Координація зацікавлених сторін",
              "Організація бізнес-процесів",
              "Конфіденційна адміністративна підтримка",
              "Підготовка презентацій",
              "Внутрішні трекери",
              "Підтримка звітності",
              "Тимчасове адміністративне покриття",
              "Постійна щомісячна адміністративна підтримка",
            ],
          },
        ],
        pricing: [
          { label: "Регулярна підтримка", value: "Від $30/год" },
          { label: "Пріоритетна підтримка", value: "Від $45/год" },
          { label: "Місячні пакети", value: "За індивідуальним розрахунком" },
        ],
        cta: "Отримати розрахунок",
      },
      {
        title: "Переклад та усний переклад",
        tagline: "Загальний та діловий письмовий і усний переклад для ділової комунікації, нарад, документів, вебсайтів, презентацій, взаємодії з клієнтами та інших нерегульованих цілей.",
        price: "Від $0.12 USD/слово",
        priceNote: "Усний переклад — від $40 USD/год",
        meta: "English | Українська | العربية | Other Languages",
        featured: ["Діловий переклад", "Переклад документів", "Відеопереклад", "Телефонний переклад", "Локалізація вебсайтів"],
        moreLabel: "Усі мовні послуги",
        groups: [
          {
            heading: "Переклад",
            items: [
              "Англійська ↔ Українська",
              "Інші мовні пари за запитом",
              "Англійська ↔ Арабська",
              "Переклад ділових документів",
              "Переклад листів",
              "Переклад вебсайтів",
              "Переклад презентацій",
              "Переклад маркетингових матеріалів",
              "Переклад описів продуктів",
              "Переклад клієнтських комунікацій",
              "Форми та анкети",
              "Політики та процедури",
              "Загальне листування",
              "Вичитка перекладених документів",
              "Редагування перекладів",
              "Локалізація",
              "Ревізія машинного перекладу",
              "Терміновий діловий переклад",
              "Переклад у неробочий час",
            ],
          },
          {
            heading: "Усний переклад",
            items: [
              "Дистанційний усний переклад",
              "Телефонний переклад",
              "Відеопереклад",
              "Переклад ділових зустрічей",
              "Переклад на прийомах і зустрічах",
              "Переклад клієнтського сервісу",
              "Суспільний усний переклад",
              "Запланований усний переклад",
              "Терміновий діловий усний переклад",
              "Усний переклад у неробочий час",
            ],
          },
        ],
        pricing: [
          { label: "Стандартний переклад", value: "Від $0.12/слово" },
          { label: "Індивідуальні бізнес-проєкти", value: "За запитом" },
          { label: "Терміновий переклад за 24 год", value: "Стандартний тариф + 35%" },
          { label: "Менше 6 годин", value: "Стандартний тариф + 50%" },
          { label: "Терміновий діловий переклад", value: "Індивідуальний розрахунок" },
          { label: "Плановий діловий усний переклад", value: "Від $40/год" },
          { label: "Пріоритетний діловий усний переклад", value: "Від $55/год" },
          { label: "Діловий усний переклад у неробочий час", value: "Від $65/год" },
        ],
        note: "VCK Business Lab не представляє свої стандартні послуги письмового та усного перекладу як сертифіковані, присяжні, судово-сертифіковані, юридичні або офіційно акредитовані, якщо це прямо не зазначено для конкретного проєкту та не виконується відповідно кваліфікованим фахівцем.",
        cta: "Розрахунок мовних послуг",
      },
      {
        title: "Багатомовна підтримка клієнтів",
        tagline: "Багатомовна клієнтська та адміністративна підтримка, що допомагає бізнесам професійно спілкуватися з клієнтами різними мовами та в різних часових поясах.",
        price: "Від $35 USD/год",
        meta: "English | Українська | العربية | Other Languages",
        featured: ["Багатомовна підтримка клієнтів", "Follow-up клієнтів", "Запис на прийом", "Email-комунікація", "Координація міжнародних клієнтів"],
        moreLabel: "Усі багатомовні послуги",
        groups: [
          {
            heading: null,
            items: [
              "Багатомовне email-листування",
              "Підтримка клієнтів по email",
              "Комунікація з клієнтами",
              "Follow-up клієнтів",
              "Планування зустрічей",
              "Нагадування про зустрічі",
              "Оновлення даних клієнтів",
              "Онбординг клієнтів",
              "Багатомовна адміністративна підтримка",
              "Міжкультурна ділова комунікація",
              "Координація міжнародних клієнтів",
              "Підтримка в живому чаті",
              "Клієнтський сервіс",
              "Підтримка FAQ",
              "Оновлення CRM",
              "Ведення баз даних",
              "Координація послуг",
              "Follow-up замовлень",
              "Прийом скарг і звернень",
              "Координація ескалацій",
              "Багатомовне ділове листування",
              "Підготовка багатомовних документів",
              "Координація між часовими поясами",
            ],
          },
        ],
        pricing: [
          { label: "Стандартна багатомовна підтримка", value: "Від $35/год" },
          { label: "Пріоритетна підтримка", value: "Від $50/год" },
          { label: "Постійна щомісячна підтримка", value: "Індивідуальний пакет" },
        ],
        cta: "Сформувати індивідуальний пакет",
      },
      {
        title: "Документи, офіс та проєктні послуги",
        tagline: "Професійна підготовка, форматування й організація документів, дослідження та проєктна підтримка для бізнесів і професіоналів.",
        price: "Від $30 USD/год",
        featured: ["Форматування Word і PDF", "Excel та трекери", "Презентації", "Ділові документи", "Дослідження та проєктна підтримка"],
        moreLabel: "Усі послуги з документами",
        groups: [
          {
            heading: "Документи",
            items: [
              "Форматування Microsoft Word",
              "Підготовка PDF",
              "Форматування PDF",
              "Форми",
              "Заповнювані документи",
              "Бізнес-шаблони",
              "Професійні листи",
              "Звіти",
              "Пакети матеріалів для нарад",
              "Форматування резюме",
              "Форматування супровідних листів",
              "Вичитка",
              "Чистка документів",
              "Редизайн документів",
              "Конвертація файлів",
              "Цифрове архівування",
              "Організація документів",
            ],
          },
          {
            heading: "Таблиці",
            items: ["Таблиці Excel", "Трекери", "Організація даних", "Трекери витрат", "Трекери інвойсів", "Бюджетні трекери", "Списки контактів", "Проєктні трекери", "Трекери дедлайнів"],
          },
          {
            heading: "Презентації та дизайн",
            items: ["Презентації PowerPoint", "Форматування презентацій", "Бізнес-матеріали в Canva", "Бізнес-флаєри", "Базові брошури", "Графіка для соцмереж", "Професійні шаблони"],
          },
          {
            heading: "Проєктна та дослідницька підтримка",
            items: ["Маркетингові дослідження", "Аналіз конкурентів", "Дослідження постачальників", "Дослідження продуктів", "Онлайн-дослідження", "Збір даних", "Порівняльні таблиці", "Формування списків контактів", "Адміністрування проєктів", "Контроль дедлайнів", "Координація follow-up", "Підсумки досліджень"],
          },
        ],
        pricing: [
          { label: "Погодинні проєкти", value: "Від $30/год" },
          { label: "Документи з фіксованою ціною", value: "За індивідуальним розрахунком" },
          { label: "Великі проєкти", value: "Індивідуальний розрахунок" },
        ],
        cta: "Отримати розрахунок проєкту",
      },
      {
        title: "Створення та підтримка вебсайтів",
        tagline:
          "Професійні вебсайти для сучасного бізнесу — ми можемо просто розробити й створити сайт для вас або підтримувати та оновлювати його довгостроково в межах місячного пакета підтримки.",
        price: "Від $40 USD/год",
        priceNote: "Разове створення — за індивідуальним розрахунком",
        featured: ["Бізнес-сайти", "Цільові сторінки", "Редизайн сайту", "Налаштування інтернет-магазину", "Постійне обслуговування"],
        moreLabel: "Усі вебпослуги",
        groups: [
          {
            heading: "Дизайн і створення — разові проєкти",
            items: [
              "Дизайн і створення бізнес-сайту",
              "Створення цільових сторінок",
              "Редизайн і оновлення сайту",
              "Мобільні адаптивні макети",
              "Налаштування інтернет-магазину / електронної комерції",
              "Налаштування контактних форм і форм бронювання",
              "Багатомовне налаштування сайту",
              "Сторінки портфоліо та галереї",
              "Блог і контентні розділи",
              "Сторінки меню, прайс-листів і каталогів",
            ],
          },
          {
            heading: "Постійна підтримка — з будь-яким місячним пакетом",
            items: [
              "Оновлення та зміни контенту",
              "Оновлення плагінів, тем і платформи",
              "Регулярне технічне обслуговування сайту",
              "Резервне копіювання та перевірки безпеки",
              "Координація домену та хостингу",
              "Базове налаштування SEO",
              "Аналітика та перевірка швидкодії",
              "Усунення несправностей сайту",
            ],
          },
        ],
        pricing: [
          { label: "Оновлення та підтримка сайту", value: "Від $40/год" },
          { label: "Разове створення сайту", value: "За запитом" },
          { label: "Постійна опіка з місячним пакетом", value: "Див. пакети" },
        ],
        note: "Ми можемо просто створити ваш вебсайт як разовий проєкт — або поєднати його з будь-яким пакетом постійної підтримки, і ми триматимемо його оновленим, захищеним і таким, що розвивається разом із вашим бізнесом, місяць за місяцем.",
        cta: "Обговорити ваш сайт",
      },
      {
        title: "Підтримка новоприбулих та іноземних студентів",
        tagline: "Адміністративна та мовна підтримка після прибуття в Канаді.",
        price: "Від $30 USD/год",
        meta: "English | Українська | العربية | Other Languages",
        featured: [
          "Запис на прийоми та планування",
          "Допомога з дзвінками та листами",
          "Загальний переклад і усний переклад",
          "Практична підтримка після прибуття",
        ],
        moreLabel: "Детальніше",
        groups: [
          {
            heading: "Що це охоплює",
            items: [
              "Практична багатомовна адміністративна та мовна підтримка для новоприбулих, іноземних студентів та осіб з обмеженим володінням англійською, які освоюються в повсякденному житті Канади.",
            ],
          },
          {
            heading: "Повсякденна координація",
            items: [
              "Запис на прийоми та планування",
              "Допомога з телефонними дзвінками та електронними листами",
              "Спілкування з канадськими компаніями та постачальниками послуг",
              "Нагадування та загальна координація",
            ],
          },
          {
            heading: "Мова та документи",
            items: [
              "Допомога у розумінні загального листування та повсякденних документів",
              "Загальний переклад і усний переклад",
              "Багатомовна підтримка у повсякденних адміністративних питаннях",
            ],
          },
          {
            heading: "Адаптація на місці",
            items: [
              "Допомога у спілкуванні зі школами, коледжами, роботодавцями та іншими організаціями",
              "Загальна адміністративна допомога",
              "Допомога у пошуку загальнодоступних послуг і ресурсів",
              "Практична підтримка після прибуття",
            ],
          },
        ],
        pricing: [
          { label: "Погодинна підтримка", value: "Від $30/год" },
          { label: "Пріоритетні запити", value: "Від $45/год" },
          { label: "Постійна підтримка", value: "Індивідуальний розрахунок" },
        ],
        note: "Важливо: VCK Business Lab надає лише загальну адміністративну, мовну та практичну підтримку. Ми не надаємо імміграційних, громадянських, юридичних, податкових, фінансових, медичних, трудових, освітніх чи інших регульованих професійних порад або представництва. Якщо потрібна допомога регульованого фахівця, клієнтам слід звернутися до відповідного ліцензованого спеціаліста.",
        cta: "Отримати розрахунок",
      },
      {
        title: "Пріоритетна та екстрена підтримка 24/7",
        tagline: "Термінова багатомовна, адміністративна, документна, перекладацька та бізнес-підтримка для клієнтів, які не можуть чекати до звичайного робочого часу.",
        price: "Від $65 USD/год",
        meta: "Доступно по всьому світу, за умови доступності команди.",
        featured: ["Терміновий діловий переклад", "Терміновий усний переклад", "Документи в останню хвилину", "Підтримка в неробочий час", "Підтримка у вихідні та свята"],
        moreLabel: "Екстрені послуги",
        groups: [
          {
            heading: null,
            items: [
              "Терміновий діловий переклад",
              "Терміновий діловий усний переклад",
              "Підготовка документів в останню хвилину",
              "Термінове форматування документів",
              "Термінові презентації",
              "Адмінпідтримка в неробочий час",
              "Адмінпідтримка у вихідні",
              "Підтримка у святкові дні",
              "Підтримка міжнародних часових поясів",
              "Термінова комунікація з клієнтами",
              "Термінова багатомовна комунікація",
              "Екстрена координація нарад",
              "Термінове планування",
              "Термінові бізнес-дослідження",
              "Екстрена підтримка клієнтського сервісу",
            ],
          },
        ],
        pricing: [
          { label: "Пріоритетна підтримка", value: "Від $45/год" },
          { label: "Підтримка в неробочий час", value: "Від $55/год" },
          { label: "Екстрена підтримка 24/7", value: "Від $65/год" },
          { label: "Критична / відповідь до 2 годин", value: "Від $75/год" },
          { label: "Екстрена підтримка у великі свята", value: "Від $85/год" },
          { label: "Мінімальна вартість екстреної послуги", value: "$65 USD" },
        ],
        note: "Екстрені послуги та послуги в неробочий час залежать від доступності. Час відповіді підтверджується до оплати клієнтом.",
        cta: "Запитати екстрену підтримку",
      },
    ],
    plans: [
      {
        price: "Від $300 USD/міс",
        fit: "Для підприємців і професіоналів, яким потрібна епізодична віртуальна підтримка.",
        features: ["До 10 годин підтримки", "Додаткові години доступні за доплату", "Адміністративна підтримка", "Планування", "Документи", "Підтримка по email"],
        cta: "Замовити пакет Essential",
      },
      {
        price: "Від $575 USD/міс",
        fit: "Для бізнесів, яким потрібна стабільна щотижнева підтримка.",
        features: ["До 20 годин підтримки", "Додаткові години доступні за доплату", "Адміністративна підтримка", "Багатомовна підтримка", "Координація нарад", "Відстеження проєктів", "Пріоритетне планування"],
        cta: "Замовити пакет Professional",
      },
      {
        price: "Від $1,100 USD/міс",
        fit: "Для керівників і бізнесів, яким потрібна постійна підтримка вищого рівня.",
        features: ["До 60 годин підтримки", "Додаткові години доступні за доплату", "Адміністрування для керівників", "Багатомовна підтримка клієнтів", "Координація нарад і проєктів", "Пріоритетна відповідь", "Виділена структура підтримки"],
        cta: "Замовити пакет Executive",
      },
      {
        price: "Індивідуальна ціна",
        fit: "Для компаній, яким потрібна міжнародна, багатомовна, розширена за часом або високообсягова підтримка.",
        features: ["Індивідуальний місячний обсяг годин", "Додаткові години доступні за доплату", "Підтримка англійською, українською, арабською та іншими мовами", "Пріоритетна допомога", "Розширена доступність за часом", "Пільгові екстрені тарифи", "Власні робочі процеси", "Кілька категорій послуг", "Виділена бізнес-підтримка"],
        cta: "Отримати індивідуальний розрахунок",
      },
    ],
    steps: [
      { title: "Зв'язок", text: "Заплануйте ознайомчу консультацію та обговоріть потреби вашого бізнесу." },
      { title: "Персоналізація", text: "Оберіть тип і рівень підтримки, що найкраще вам підходить." },
      { title: "Делегування", text: "Передайте адміністративні завдання, які хочете зняти з себе." },
      { title: "Фокус", text: "Приділіть більше часу клієнтам, проєктам і зростанню, поки VCK піклується про адміністративні деталі." },
    ],
    why: [
      { title: "Професійно та надійно", text: "Стабільна підтримка, на яку можна планувати." },
      { title: "Гнучка віртуальна підтримка", text: "Підтримка масштабується під ваше навантаження — без жорстких контрактів." },
      { title: "Увага до деталей", text: "Кожне завдання виконується ретельно, перевіряється та здається на високому рівні." },
      { title: "Конфіденційно за замовчуванням", text: "Ділова інформація обробляється зі суворою конфіденційністю та розумними заходами захисту; угоди про конфіденційність доступні за потреби." },
      { title: "Чітка комунікація", text: "Професійна, оперативна та прозора комунікація на кожному кроці." },
      { title: "Персоналізація під вас", text: "Підтримка адаптується під інструменти, вподобання та стиль роботи кожного клієнта." },
      { title: "Без штатного працівника", text: "Підтримка високого рівня без витрат і зобов'язань найму." },
      { title: "Постійно або проєктно", text: "Доступні як тривала щомісячна підтримка, так і разові завдання." },
      { title: "Віртуально по всьому світу", text: "Клієнти в Канаді, США, Європі та міжнародно." },
    ],
    clients: ["Підприємці", "Малий бізнес", "Консультанти", "Керівники", "Професіонали", "Стартапи", "Незалежні підрядники", "Зайняті власники бізнесу", "Організації, яким потрібна тимчасова адмінпідтримка", "Приватні особи", "Новоприбулі до Канади", "Іноземні студенти", "Міжнародні сім'ї", "Професіонали, які переїжджають до Канади", "Особи з обмеженим володінням англійською", "Україномовні клієнти", "Арабомовні клієнти"],
    faqs: [
      { q: "Що таке віртуальний адміністративний асистент?", a: "Віртуальний адміністративний асистент — це професіонал, який надає адміністративну, організаційну та бізнес-підтримку віддалено. Ви отримуєте ту ж надійну, якісну допомогу, що й від офісного адміністратора, — без витрат, обладнання та зобов'язань штатного найму." },
      { q: "Чи можна найняти VCK Business Lab лише на кілька годин?", a: "Так. Підтримка гнучка за своєю природою. Ви можете залучити VCK лише на кілька годин епізодичної допомоги, на разовий проєкт або на короткострокове завдання — мінімальних щомісячних зобов'язань немає." },
      { q: "Чи пропонуєте ви постійну щомісячну підтримку?", a: "Так. Пакети Professional та Executive забезпечують регулярну щотижневу та щомісячну допомогу для клієнтів, яким потрібна стабільна підтримка щоденного адміністрування." },
      { q: "Чи працюєте ви з міжнародними клієнтами?", a: "Звичайно. Усі послуги надаються на 100% віддалено, тому VCK Business Lab підтримує клієнтів у Канаді, США, Європі та міжнародно. Звернення міжнародних клієнтів завжди вітаються." },
      { q: "Чи берете ви разові проєкти?", a: "Так. Індивідуальні проєкти охоплюють разові завдання: форматування документів, дослідження, координацію подій та організацію процесів — кожен із чітким фіксованим розрахунком до початку роботи." },
      { q: "Як безпечно передати вам документи та інформацію?", a: "Документи передаються через безпечні канали з контролем доступу, наприклад зашифроване хмарне сховище та платформи обміну файлами. Доступ обмежений лише тим, що потрібно для вашої співпраці, а угоди про конфіденційність завжди доступні на запит." },
      { q: "З яким програмним забезпеченням ви працюєте?", a: "VCK вільно працює з Microsoft 365 — Word, Excel, Outlook, Teams, PowerPoint — а також Google Workspace, PDF-інструментами та Acrobat, Zoom і більшістю поширених бізнес-платформ. Якщо ваш бізнес використовує інший інструмент — просто запитайте." },
      { q: "Чи допомагаєте ви з Microsoft Word, Excel, Outlook, Teams і PDF-документами?", a: "Так — це ядро нашої роботи: професійне форматування документів Word, таблиці та трекери Excel, керування поштою та календарем в Outlook, координація нарад у Teams, а також підготовка та форматування PDF." },
      { q: "Чи зберігається конфіденційність моїх ділових документів?", a: "Завжди. Конфіденційне поводження з діловою інформацією — засновницький принцип VCK Business Lab. Ваші документи ніколи не передаються, не обговорюються і не використовуються поза межами вашої співпраці, і ми з радістю формалізуємо це угодою про нерозголошення." },
      { q: "Як працює оплата?", a: "Ціни прозорі та індивідуальні — кожна співпраця починається зі стартового тарифу, що уточнюється після короткої консультації. Постійні пакети виставляються щомісяця, разові проєкти мають фіксований розрахунок, а довгострокові контракти не потрібні." },
      { q: "Як я можу оплатити послуги?", a: "Після підтвердження ваших потреб, обсягу та вартості VCK Business Lab надішле вам безпечне платіжне посилання безпосередньо. Інструкції щодо оплати надаються до початку роботи або відповідно до узгоджених умов оплати — вебсайт не пропонує публічної сторінки оплати." },
      { q: "Чи працюєте ви з приватними особами та новоприбулими, чи лише з бізнесами?", a: "З обома. Поруч із бізнес-послугами VCK пропонує персональну підтримку та підтримку новоприбулих — мовну допомогу, допомогу у спілкуванні з банками, страховими, комунальними службами, орендодавцями та школами, а також повсякденну адміністративну підтримку для приватних осіб, сімей і новоприбулих до Канади." },
      { q: "Чи можете ви допомогти з імміграційними заявами, юридичними питаннями чи фінансовими порадами?", a: "Ні — і ми дбаємо про те, щоб це було зрозуміло. VCK Business Lab не надає імміграційних, юридичних, фінансових, страхових, податкових чи медичних порад і не готує та не подає імміграційні заяви. Наші персональні послуги охоплюють лише комунікацію, організацію та адміністрування. Коли потрібен ліцензований або регульований фахівець, ми завжди скажемо про це й допоможемо знайти його." },
    ],
    testimonials: [
      {
        quote:
          "Working with this team was a smooth and professional experience from start to finish. They created a modern, clear, and user-friendly website for my legal practice in Ukraine that presents my services in a professional way and makes it easy for clients to find the information they need.\n\nThey listened carefully to my requirements, communicated clearly throughout the process, and delivered a website that reflects my work and professional image very well.\n\nI am very satisfied with the result and would gladly recommend their services to other professionals and businesses looking for reliable website and digital support.",
        name: "Anton",
        detail: "Адвокат, Україна",
      },
    ],
    loyaltyTiers: [
      { months: "1 місяць", hours: "3 безкоштовні години", note: "Чудовий спосіб почати та відчути підтримку VCK із маленьким бонусом від нас.", extras: [] },
      { months: "3 місяці", hours: "8 безкоштовних годин", extras: ["Безкоштовний вітальний пакет VCK", "Пріоритетне планування", "Гнучка підтримка у відповідних послугах"] },
      { months: "6 місяців", hours: "18 безкоштовних годин", extras: ["Преміальний вітальний пакет VCK", "Пріоритетне планування", "Пріоритетне бронювання проєктів", "Пільгові тарифи на окремі термінові послуги"] },
      { months: "12 місяців", hours: "36 безкоштовних годин", extras: ["Преміальний вітальний пакет VCK", "Пріоритетне планування", "Пріоритетне бронювання проєктів", "Пільгові екстрені тарифи", "Безкоштовна щорічна сесія планування підтримки", "Ексклюзивні переваги постійного клієнта"] },
    ],
    loyaltyServices: ["Віртуальна адміністративна підтримка", "Підтримка керівників", "Багатомовна підтримка клієнтів", "Допомога з документами та проєктами", "Перекладацькі послуги", "Інші відповідні бізнес-послуги VCK"],
    marquee: ["Віртуальна адміністративна підтримка", "Керування календарем керівника", "Документи та бізнес-підтримка", "Координація нарад", "Координація бізнесу та проєктів", "Конфіденційна підтримка керівників"],
    comparison: {
      columns: ["Essential", "Professional", "Executive", "Global Priority"],
      rows: [
        { label: "Щомісячні години підтримки", values: ["До 10", "До 20", "До 60", "Індивідуально"] },
        { label: "Адміністративна підтримка", values: [true, true, true, true] },
        { label: "Багатомовна підтримка", values: [false, true, true, true] },
        { label: "Координація нарад і проєктів", values: [false, true, true, true] },
        { label: "Адміністрування для керівників", values: [false, false, true, true] },
        { label: "Пріоритетна відповідь і планування", values: [false, true, true, true] },
        { label: "Розширена доступність за часом", values: [false, false, false, true] },
        { label: "Пільгові екстрені тарифи", values: [false, false, false, true] },
        { label: "Виділена структура підтримки", values: [false, false, true, true] },
        { label: "Ціна", values: ["Від $300/міс", "Від $575/міс", "Від $1,100/міс", "Індивідуально"] },
      ],
    },
    aboutChapters: [
      { title: "Бутік-відмінність", text: "VCK свідомо залишається бутік-компанією. Ви працюєте безпосередньо з виділеним професіоналом, який вивчає, як працює ваш бізнес, — а не зі змінним пулом анонімних асистентів. Кожна деталь, вподобання та стандарт запам'ятовуються й поважаються." },
      { title: "Тиха делікатність", text: "Довіра — фундамент кожної співпраці. Конфіденційна ділова інформація обробляється дбайливо, захищається безпечними каналами та ніколи не обговорюється поза межами вашої співпраці." },
      { title: "Нескомпромісна точність", text: "Від ідеально відформатованого документа до бездоганно скоординованого календаря — стандарт однаковий щоразу: точно, бездоганно та вчасно. Деталі і є робота." },
    ],
    aboutValues: [
      { title: "Професіоналізм", text: "Бездоганний, надійний стандарт у кожній взаємодії та кожному результаті." },
      { title: "Організованість", text: "Структура та порядок для скриньок, календарів, файлів і процесів." },
      { title: "Комунікація", text: "Чітко, оперативно та професійно — ви завжди знаєте, на якому етапі справи." },
      { title: "Клієнтський сервіс", text: "Уважна, персональна підтримка, адаптована під стиль роботи кожного клієнта." },
    ],
  },
};
